export default "__VITE_ASSET__f7c98c2d__"